<template>
  <div class="highlight-card-parts">
    <div class="highlight-card-parts__race-angle">
      <div class="highlight-card-parts__header">
        <div class="highlight-card-parts__header__player">
          <img
            class="highlight-card-parts__header__player-img"
            :src="
              highlight.player.playerPictureImagePath
                ? highlight.player.playerPictureImagePath
                : require('@/assets/img/icon/icon_player__null.svg')
            "
            :alt="highlight.player.playerName[$i18n.locale]"
          />
          <span
            class="highlight-card-parts__header__player-name"
            v-text="highlight.player.playerName[$i18n.locale]"
          />
        </div>
        <div class="highlight-card-parts__header__time">{{ highlight.raceTime }}</div>
      </div>
      <figure
        class="highlight-card-parts__thumbnail"
        :class="{ 'highlight-card-parts__thumbnail--blank': !highlight.thumbnailUri }"
      >
        <img
          :src="
            highlight.thumbnailUri
              ? highlight.thumbnailUri
              : require('@/assets/img/icon/icon_play__gray.svg')
          "
          alt=""
        />
      </figure>
    </div>
    <p
      class="highlight-card-parts__parent-comment"
      v-if="highlight.comment"
      v-html="highlight.comment"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { HighlightSceneType } from '@/components/NotificationPane/NotificationPane.vue'

/**
 * Notification: ハイライトカード パーツコンポーネント
 */
export default defineComponent({
  name: 'HighlightItemParts',
  props: {
    highlightData: {
      type: Object as PropType<HighlightSceneType>,
      required: true,
    },
  },
  setup(props) {
    const highlight = computed(() => props.highlightData)

    return {
      highlight,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.highlight-card-parts {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  background: $black80;
  border-radius: 4px;

  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 8px 8px 16px;
    color: $white;
    background: $black20;
    border-radius: 4px 4px 0 0;

    &__player {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      gap: 8px;
      max-width: calc(100% - 86px);

      &-img {
        width: 24px;
        min-width: 24px;
        height: 24px;
        border-radius: 50%;
      }

      &-name {
        display: block;
        max-width: calc(100% - 32px);
        font-family: $fontSignup;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.53846;
        letter-spacing: 0.04em;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    &__time {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 76px;
      margin-left: 8px;
      height: 24px;
      white-space: nowrap;
      text-align: center;
      font-size: 12px;
      line-height: 1.33;
      letter-spacing: 0.04em;
      border-radius: 2px;
      background: rgba(0, 0, 0, 70%);
      font-family: $fontFamilyDefault;
    }
  }

  &__thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: $black90;

    img {
      width: 100%;
      aspect-ratio: 65 / 24;
      object-fit: cover;
    }

    &--blank {
      height: 64px;

      img {
        width: 32px;
        aspect-ratio: unset;
        object-fit: unset;
      }
    }
  }

  &__race-angle {
    cursor: pointer;

    &:last-child .highlight-card-parts__thumbnail {
      border-radius: 0 0 4px 4px;
      overflow: hidden;
    }
  }

  &__parent-comment {
    width: 100%;
    padding: 10px 16px;
    border-top: 1px solid $black;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.67;
    letter-spacing: 0.02em;
    color: $white;
    white-space: pre-wrap;
  }
}
</style>
